
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, List, ListItem } from "@mui/material";

export default function StatusDetailsDialog({doShow, handleClose, title, statuses}) {
    return (
      <Dialog
        open={doShow}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
        <DialogContent>
            <List sx={{ listStyleType: "disc", paddingLeft: "8px", paddingTop: "0px", paddingBottom: "0px" }}>
                {statuses.map((s,idx) => 
                    <ListItem  key={`status-details-dialog-${idx}`} sx={{ display: "list-item", paddingTop: "0px", paddingBottom: "0px" }}>{s}</ListItem>
                )}
            </List>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="primary" variant="outlined">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
}